import { Space } from 'component/Space/Space'
import { Typo } from 'component/Typo/Typo'
import { Vertical } from 'component/Vertical/Vertical'
import { Icon } from 'icon/Icon'
import css from './ErrorPage.module.scss'

type Props = {
  text: string
}

export const ErrorPage = ({ text }: Props) => {
  return <Vertical gap={12} className={css.error}>
    <Space gap={8}>
      <Icon name="error" size={20} error />
      <Typo size={14} error>{text}</Typo>
    </Space>
  </Vertical>
}
